import React from "react";
//
import { Container } from "@mantine/core";
//
import type { UiSection } from "@neuromotion-inc/mightier-survey-engine";
import type { SurveyEngineIface } from "src/services/surveyHooks/useSurveyEngine";
import { SurveyRichText } from "../survey-rich-text/survey-rich-text";
// tyles
import css from "./survey-ui-section.module.css";

interface SurveyUiSectionProps {
  section: UiSection;
  surveyEngine: SurveyEngineIface;
}

export const SurveyUiSection = React.memo<SurveyUiSectionProps>(
  function SurveyUiSection(props) {
    const { section, surveyEngine } = props;

    return (
      <Container>
        {section.title ? (
          <SurveyRichText
            text={section.title.translation_key}
            className={css["title-text"]}
            surveyEngine={surveyEngine}
          />
        ) : null}

        {section.description ? (
          <SurveyRichText
            text={section.description}
            className={css["description-text"]}
            surveyEngine={surveyEngine}
          />
        ) : null}
      </Container>
    );
  },
);
